import {
  animate,
  animateChild,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const drawerToggle = trigger('issDrawerToggle', [
  transition(
    ':enter',
    [ query('@issSlideInRight', animateChild()) ],
  ),
  transition(
    ':leave',
    [ query('@issSlideInRight', animateChild()) ],
  ),
]);

export const slideInRight = trigger('issSlideInRight', [
  transition(
    ':enter',
    [
      style({ transform: 'translateX(100%)' }),
      animate('300ms ease-in-out', style({ transform: 'translateX(0)' })),
    ],
  ),
  transition(
    ':leave',
    [
      style({ transform: 'translateX(0)' }),
      animate('300ms ease-in-out', style({ transform: 'translateX(100%)' })),
    ],
  ),
]);
